import { useEffect, useRef, useState } from "react";

export function useScrollReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setVisible(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            io.unobserve(entry.target);
          }
        });
      },
      {
        threshold: options.threshold ?? 0.01,
        // Trigger well before the element actually enters the viewport
        rootMargin: options.rootMargin ?? "0px 0px 300px 0px",
      }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [options.threshold, options.rootMargin]);
  return { ref, visible };
}

export function Reveal({ children, as: Tag = "div", className = "", ...rest }) {
  const { ref, visible } = useScrollReveal();
  return (
    <Tag ref={ref} className={`tv-reveal ${visible ? "tv-visible" : ""} ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
